import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent, IconProps} from '../types';

const largeIcon = [
  <path
    key="1"
    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
  />,
  <path
    key="2"
    d="M9.29998 9.04217H13.3068V15.1767H15.3V16.7964H9.29998V15.1767H11.3952V10.669H9.29998V9.04217ZM11.2592 7.05704C11.2592 6.90415 11.2841 6.76321 11.334 6.63421C11.3884 6.50043 11.4632 6.38816 11.5585 6.29738C11.6537 6.20183 11.7671 6.12777 11.8986 6.07522C12.0347 6.02266 12.1843 5.99639 12.3476 5.99639C12.6832 5.99639 12.9485 6.09672 13.1435 6.29738C13.3431 6.49327 13.4428 6.74649 13.4428 7.05704C13.4428 7.36759 13.3431 7.6232 13.1435 7.82386C12.9485 8.01974 12.6832 8.11769 12.3476 8.11769C12.1843 8.11769 12.0347 8.09141 11.8986 8.03886C11.7671 7.9863 11.6537 7.91464 11.5585 7.82386C11.4632 7.7283 11.3884 7.61603 11.334 7.48703C11.2841 7.35326 11.2592 7.20992 11.2592 7.05704Z"
  />,
];

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 13.87C11.2419 13.87 13.87 11.2419 13.87 8C13.87 4.75809 11.2419 2.13 8 2.13C4.75809 2.13 2.13 4.75809 2.13 8C2.13 11.2419 4.75809 13.87 8 13.87ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.5 7.5C6.5 7.22386 6.72386 7 7 7H8C8.55228 7 9 7.44772 9 8V11H10C10.2761 11 10.5 11.2239 10.5 11.5C10.5 11.7761 10.2761 12 10 12H6.5C6.22386 12 6 11.7761 6 11.5C6 11.2239 6.22386 11 6.5 11H8V8H7C6.72386 8 6.5 7.77614 6.5 7.5ZM7.89998 5.90005C8.3418 5.90005 8.69998 5.54188 8.69998 5.10005C8.69998 4.65822 8.3418 4.30005 7.89998 4.30005C7.45815 4.30005 7.09998 4.65822 7.09998 5.10005C7.09998 5.54188 7.45815 5.90005 7.89998 5.90005Z"
  />
);

const xSmallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7 12.87C10.2419 12.87 12.87 10.2419 12.87 7C12.87 3.75809 10.2419 1.13 7 1.13C3.75809 1.13 1.13 3.75809 1.13 7C1.13 10.2419 3.75809 12.87 7 12.87ZM7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.5 6.5C5.5 6.22386 5.72386 6 6 6H7C7.55228 6 8 6.44772 8 7V10H9C9.27614 10 9.5 10.2239 9.5 10.5C9.5 10.7761 9.27614 11 9 11H5.5C5.22386 11 5 10.7761 5 10.5C5 10.2239 5.22386 10 5.5 10H7V7H6C5.72386 7 5.5 6.77614 5.5 6.5ZM6.89998 4.90005C7.3418 4.90005 7.69998 4.54188 7.69998 4.10005C7.69998 3.65822 7.3418 3.30005 6.89998 3.30005C6.45815 3.30005 6.09998 3.65822 6.09998 4.10005C6.09998 4.54188 6.45815 4.90005 6.89998 4.90005Z"
  />
);

export const InfoIcon: IconComponent = forwardRef((props, ref) => {
  const svgProps: IconProps = {...props, children: largeIcon};

  switch (props.size) {
    case SizeTokenValue.Small:
    case SizeTokenValue.XXSmall:
      svgProps.children = smallIcon;
      break;

    case SizeTokenValue.XSmall:
      svgProps.children = xSmallIcon;
      svgProps.viewBox ??= '0 0 14 14';
      break;
  }

  return <SVG ref={ref} name="Done" {...svgProps} />;
});
